<mc-loading [overlay]="true" [image]="loadingGif" *ngIf="loading"></mc-loading>
<div class="pexels-container p-0">
    <!-- PEXELS FILTERS -->
    <div *ngIf="!loading" class="d-flex align-items-center justify-content-between col-12 px-2">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-12">
                    <!-- Buscador ocupa el 100% del ancho -->
                    <form [formGroup]="pexelsForm" *ngIf="pexelsForm">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="position-relative w-100">
                                    <i class="fal fa-search mr-2 icon-input icon-search-input"></i>
                                    <input
                                        class="form-control"
                                        id="searchValue"
                                        name="searchValue"
                                        form="pexelsForm"
                                        formControlName="searchValue"
                                        type="search"
                                        placeholder="{{
                                            'app.global.modals.image_manager.upload_image_modal.pexels.filters.buscar'
                                                | translate
                                        }}"
                                    />
                                    <i
                                        *ngIf="pexelsForm.get('searchValue')?.value?.length"
                                        class="fa fa-regular fa-xmark mr-2 icon-input icon-clear-input"
                                        (click)="clearSearchInput()"
                                    ></i>
                                </div>
                            </div>
                        </div>
                        <!-- Fila con los 2 selects -->
                        <div class="row">
                            <div class="col-md-6 col-12 mb-3">
                                <div class="position-relative">
                                    <div class="custom-color-select form-control w-100" [matMenuTriggerFor]="menu">
                                        <div class="d-flex">
                                            <ng-container [ngSwitch]="filterColor">
                                                <ng-container *ngSwitchCase="pexelsColors.NONE">
                                                    <span class="custom-color-select-option">{{
                                                        'app.global.modals.image_manager.upload_image_modal.pexels.filters.colores.label'
                                                            | translate
                                                    }}</span>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="pexelsColors.ALL">
                                                    <span class="custom-color-select-option">{{
                                                        'app.global.modals.image_manager.upload_image_modal.pexels.filters.colores.todos'
                                                            | translate
                                                    }}</span>
                                                    <div class="color-circle all-colors"></div>
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    <span class="custom-color-select-option">{{
                                                        getPexelColorData().name
                                                    }}</span>
                                                    <div
                                                        class="color-circle"
                                                        [ngStyle]="{ background: getPexelColorData().id }"
                                                    ></div>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                        <i class="fa-solid fa-angle-down"></i>
                                        <mat-menu #menu="matMenu" class="color-menu">
                                            <div class="menu-header">
                                                <span>{{
                                                    'app.global.modals.image_manager.upload_image_modal.pexels.filters.colores.title'
                                                        | translate
                                                }}</span>
                                            </div>
                                            <button
                                                mat-menu-item
                                                class="menu-item"
                                                (click)="updateColorFilter(pexelsColors.ALL)"
                                            >
                                                <span>{{
                                                    'app.global.modals.image_manager.upload_image_modal.pexels.filters.colores.todos'
                                                        | translate
                                                }}</span>
                                                <div class="color-circle all-colors"></div>
                                            </button>
                                            <div mat-menu-item class="menu-item">
                                                <span>{{
                                                    'app.global.modals.image_manager.upload_image_modal.pexels.filters.colores.especifico'
                                                        | translate
                                                }}</span>
                                                <div class="color-grid">
                                                    <div
                                                        *ngFor="let color of colorOptions"
                                                        class="color-circle"
                                                        [ngStyle]="{ background: color.id }"
                                                        (click)="updateColorFilter(color.id)"
                                                    ></div>
                                                </div>
                                            </div>
                                        </mat-menu>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-12 mb-3">
                                <div class="position-relative">
                                    <select class="form-control w-100" id="filter_order" formControlName="orientation">
                                        <ng-container *ngFor="let option of orientationOptions; let i = index">
                                            <option [value]="option.id">
                                                {{ option.name }}
                                            </option>
                                        </ng-container>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- PEXELS FILTERS -->

    <!-- PEXELS EMPTY STATE -->
    <div
        *ngIf="(showEmptyState$ | async) && !loading"
        class="container-box mt-4 d-flex flex-wrap justify-content-center"
    >
        <pexels-empty-state></pexels-empty-state>
    </div>
    <!-- PEXELS EMPTY STATE -->

    <!-- Imgs -->
    <div
        *ngIf="pexelsImages"
        class="container-box pt-4 d-flex flex-wrap justify-content-center justify-content-lg-start"
        (scroll)="onScroll($event)"
    >
        <ng-container *ngFor="let photo of pexelsImages; let i = index">
            <div class="img-container position-relative m-3" (click)="toggleFileSelection(photo)">
                <!-- <img class="w-100" src="{{ photo.src?.tiny }}" [alt]="photo.alt" /> -->
                <img class="w-100" src="{{ getPhotoUrl(photo.src) }}" [alt]="photo.alt" />
                <div class="info-container text-center mt-2">
                    <p class="photographer mb-1">
                        {{
                            'app.global.modals.image_manager.upload_image_modal.pexels.image.photographer' | translate
                        }}:
                        <strong>{{ photo.photographer }}</strong>
                    </p>
                    <p class="photographer-url mb-1">
                        <a class="color-link" target="_blank" [href]="photo.photographer_url">
                            {{ getUser(photo.photographer_url) }}
                        </a>
                    </p>
                    <p
                        *ngIf="photo.alt?.length"
                        class="alt-description mb-1"
                        [ngbTooltip]="photo.alt.length > 25 ? photo.alt : ''"
                    >
                        {{ photo.alt.length > 25 ? photo.alt.slice(0, 22) + '...' : photo.alt }}
                    </p>
                </div>
                <input
                    [checked]="selectedFiles.has(photo)"
                    type="checkbox"
                    class="position-absolute top-0 end-0 mt-2 me-2"
                />
                <div class="buttons-container d-flex flex-wrap justify-content-end">
                    <i
                        class="fa-light fa-magnifying-glass"
                        (click)="openCarouselModal(i); $event.stopPropagation()"
                    ></i>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- Imgs -->

    <div *ngIf="pexelsImages.length" class="col-12 d-flex justify-content-start w-100 mt-3 mt-lg-4 footer">
        <span>{{ 'app.global.modals.image_manager.upload_image_modal.pexels.footer_1' | translate }}</span>
        <img
            class="ml-1"
            width="20"
            height="20"
            src="{{ assetsUrl }}{{ mfsPath }}/img/front/images/pexelsIcon.png"
            [alt]="'PEXELS LOGO'"
        />
        <strong class="mr-1">PEXELS</strong
        ><span>{{ 'app.global.modals.image_manager.upload_image_modal.pexels.footer_2' | translate }}</span>
        <a class="color-link ml-1" target="_blank" href="https://www.pexels.com/terms-of-service/">
            {{ 'app.global.modals.image_manager.upload_image_modal.pexels.footer_link' | translate }}</a
        >
    </div>

    <div class="col-sm-12 col-md-6 col-lg-6 mb-3 mt-2">
        <div class="position-relative">
            <form [formGroup]="pexelsForm" *ngIf="pexelsForm">
                <label for="state" class="input-label">
                    {{ 'app.global.modals.image_manager.upload_image_modal.pexels.elige_el_tamaño' | translate }}
                    <span class="text-danger"> (*) </span>
                </label>
                <select
                    class="form-control w-100"
                    id="filter_size"
                    formControlName="size"
                    (change)="selectSize($event.target.value)"
                >
                    <ng-container *ngFor="let size of sizes; let i = index">
                        <option [value]="size">
                            {{
                                'app.global.modals.image_manager.upload_image_modal.pexels.buttons.size.' + size
                                    | translate
                            }}
                        </option>
                    </ng-container>
                </select>
            </form>
        </div>
    </div>

    <div *ngIf="pexelsImages.length" class="d-flex justify-content-between justify-content-sm-end mt-3 mt-lg-4">
        <button class="btn btn-skip mr-0 mr-sm-4" tabindex="0" (click)="reset()">
            {{ 'app.global.modals.image_manager.upload_image_modal.pexels.buttons.cancel' | translate }}
        </button>

        <button
            class="btn btn-continue"
            type="submit"
            tabindex="0"
            (click)="upload()"
            [disabled]="!selectedFiles.size || loading"
        >
            <mc-loading *ngIf="loading" [overlay]="true" color="text-white" size="sm"></mc-loading>
            {{ 'app.global.modals.image_manager.upload_image_modal.pexels.buttons.add' | translate }}
        </button>

        <!-- <div class="btn-group dropup" ngbDropdown>
            <button
                class="btn btn-continue"
                type="submit"
                tabindex="0"
                (click)="upload()"
                [disabled]="!selectedFiles.size || loading"
            >
                <mc-loading *ngIf="loading" [overlay]="true" color="text-white" size="sm"></mc-loading>
                {{ 'app.global.modals.image_manager.upload_image_modal.pexels.buttons.add' | translate }}
                {{ selectedSizeTranslated }}
            </button>

            <button
                class="btn btn-continue dropdown-toggle dropdown-toggle-split"
                ngbDropdownToggle
                [disabled]="loading"
                aria-label="Toggle dropup"
            >
                <span class="visually-hidden"></span>
            </button>

            <div ngbDropdownMenu>
                <button *ngFor="let size of sizes" class="dropdown-item" (click)="selectSize(size)">
                    {{ 'app.global.modals.image_manager.upload_image_modal.pexels.buttons.size.' + size | translate }}
                </button>
            </div>
        </div> -->
    </div>
</div>
